import {
  getQueryStringParams,
  deleteQueryStringParam,
} from "../../shared/utils";

export const triageSquadManagerStore = {
  setInitialState({
    incompleteSquads,
    hasMultipleTeams,
    snapshotSquadId,
    snapshotSquads,
  }) {
    const openAutomatically = getQueryStringParams().get("triage") == "1";

    this.incompleteSquads = incompleteSquads;
    this.hasMultipleTeams = hasMultipleTeams;
    this.snapshotSquadId = snapshotSquadId;
    this.snapshotSquads = snapshotSquads;

    if (openAutomatically) {
      if (this.hasMultipleTeams) {
        this.multiTeamModalOpen = true;
      } else {
        this.squadViewModalOpen = true;
      }
    }
  },
  numIncomplete() {
    return Object.keys(this.incompleteSquads).length;
  },
  openTriageModal() {
    this.hasMultipleTeams
      ? (this.multiTeamModalOpen = true)
      : (this.squadViewModalOpen = true);
  },
  clearOpenAutomaticallyParam() {
    deleteQueryStringParam("triage");
  },
};
